/*
 * Client-side item response validation
*/
/* eslint-disable-next-line */
var aptValidation: any = aptValidation || {}
aptValidation = (function ($: JQueryStatic) {
	const _init = function () {
		if ($("[data-validation='true']").length < 1) return;

		$("[data-validation='true']").each(function () {

			const validationElement: JQuery<HTMLElement> = $(this);
			const validationType: string = validationElement.data("validationtype");
			let validator: ItemValidatorBase;

			switch (validationType) {
				case "rankOrder": { validator = new RankOrderValidator(validationElement); break; }
				case "textbox": { validator = new TextBoxValidator(validationElement); break; }
				case "textarea": { validator = new TextAreaValidator(validationElement); break; }
				case "checkBox": { validator = new CheckBoxValidator(validationElement); break; }
				case "dropdown": { validator = new DropDownValidator(validationElement); break; }
				case "constantSum": { validator = new ConstantSumValidator(validationElement); break; }
				case "mostLeast": { validator = new MostLeastValidator(validationElement); break; }
				case "rankOrderDnD": { validator = new RankOrderDragDropValidator(validationElement); break; }
				default: { validator = new RadioButtonValidator(validationElement); break; }
			}

			if (validator) {
				validator.attachEventHandler(validator);
				$("form").on("submit", function () { return validator.validate(); });
				$("#previous").on("click", function () { validator.isPrevious = true; })
			}
		});
	}

	const _showHideNextButtonTextArea = function () {
		const _nextButton: JQuery<HTMLElement> = $("#next");
		let allChecked = true;
		$(".confirmDoneTyping").each(function () {
			if (!($(this).prop("checked"))) {
				allChecked = false;
			}
		});
		if (allChecked)
			_nextButton.removeClass("invisible");
		else
			_nextButton.addClass("invisible");
	}

	abstract class ItemValidatorBase {

		abstract validate(element?: HTMLElement): boolean;
		abstract attachEventHandler(validator: ItemValidatorBase): void;
		abstract hasResponses(): boolean;
		public isValid = this.validate

		constructor(element: JQuery<HTMLElement>) {
			this.validationElement = element;
			this.isRequired = element.data("responserequired").toLowerCase() === "true";
			this.errorLabel = element.closest(".item-view").find(".error");
			this.responseRequiredMessage = element.data("msg-required");
			this.invalidResponseMessage = element.data("msg-invalid") || "";
		}

		protected readonly validationElement: JQuery<HTMLElement>;
		private readonly isRequired: boolean;
		private readonly responseRequiredMessage: string;
		private readonly invalidResponseMessage: string;
		protected readonly errorLabel: JQuery<HTMLElement>;
		public isPrevious: boolean = false;

		protected get required() { return this.isRequired; }
		protected get hasErrorMessage() { return this.errorLabel.html().trim() !== ""; }

		protected setResponseRequired(errorLabel?: JQuery<HTMLElement>): boolean {
			const label = errorLabel ? errorLabel : this.errorLabel;

			if (this.isPrevious && !this.hasResponses()) { this.clearErrorMessage(); return true; }

			label.html(this.responseRequiredMessage);
			document.getElementById('surveyForm')!.scrollTo(0, label.position().top + 50)
			return false;
		}

		protected setInvalidResponse(errorLabel?: JQuery<HTMLElement>) {
			const label = errorLabel ? errorLabel : this.errorLabel;

			label.html(this.invalidResponseMessage);
			document.getElementById('surveyForm')!.scrollTo(0, label.position().top + 50)
		}

		protected clearErrorMessage(errorLabel?: JQuery<HTMLElement>) {
			if (!errorLabel) this.errorLabel.empty();
			else errorLabel.empty();
		}
	}

	class ConstantSumValidator extends ItemValidatorBase {

		constructor(element: JQuery<HTMLElement>) {
			super(element);
			this.csInputs = element.find(".cs-input");
			this.csSum = element.find(".cs-sum");
			this.invalidSumMessage = element.data("msg-invalidsum") || "";
			this.validatingSum = false;
			this.loadSum();
		}

		private readonly csInputs: JQuery<HTMLElement>;
		private readonly csSum: JQuery<HTMLElement>;
		private readonly invalidSumMessage: string;

		// This variable controls whether an error message is displayed if the current sum is not 100.
		// It is set to false when the page is first loaded.  Once it is set to true it remains true.
		// It is set to true in the following conditions:
		//    1. The user attempts to submit.
		//    2. The sum exceeds 100.
		private validatingSum: boolean;

		// Test if a string contains one or more numeric digits
		private isNumeric(value: string): boolean {
			const numbers = /^[0-9]+$/;
			return numbers.test(value);
		}

		// Sum all the response options that are valid numbers and load into the page.
		// If we are currently validating the sum, then call validateSum.
		private loadSum(): boolean {
			let sum = 0;
			const validator = this as ConstantSumValidator;
			this.csInputs.each(function (index, element) {
				const currentValue: string = $(element).val() as string;
				if (validator.isNumeric(currentValue)) sum += Number(currentValue);
			});
			this.csSum.val(sum);
			if (sum > 100) this.validatingSum = true;
			if (this.validatingSum) return this.validateSum(sum);
			return false;
		}

		// Display an error message if the sum is not 100.
		private validateSum(sum: number): boolean {
			const errorLabel: JQuery<HTMLElement> = $("#" + this.csSum.attr("id") + "-error");
			if (sum === 100) {
				this.clearErrorMessage(errorLabel);
				return true;
			}
			errorLabel.html(this.invalidSumMessage);
			return false;
		}

		validate(selectedElement?: HTMLElement): boolean {
			let valid = true;
			const validator = this as ConstantSumValidator;

			this.csInputs.each(function (index, element) {
				const currentValue: string = $(element).val() as string;
				const errorLabel: JQuery<HTMLElement> = $("#" + $(element).attr("id") + "-error");

				if (validator.required && currentValue === "") {
					// only call responseRequired if selected element is null (submit) or selected element matches current element in iteration
					if (!selectedElement || element === selectedElement) {
						valid = validator.setResponseRequired(errorLabel);
					}
				}
				else if (!validator.isNumeric(currentValue)) {
					validator.setInvalidResponse(errorLabel);
					valid = false;
				}
				else
					validator.clearErrorMessage(errorLabel);
			});

			if (!selectedElement) this.validatingSum = true;
			if (!this.isPrevious || (this.isPrevious && this.hasResponses()))
				if (!this.loadSum()) valid = false;
			return valid;
		}

		attachEventHandler(validator: ConstantSumValidator) {
			validator.csInputs.on('keyup', function (e) {
				if (e.key !== "Tab") validator.validate(this);
			});
		}

		hasResponses() {
			let hasResponses = false;
			this.csInputs.each(function (index, element) {
				if ($(element).val() != "") { hasResponses = true; return false; }
			});
			return hasResponses;
		}
	}

	class RankOrderValidator extends ItemValidatorBase {

		constructor(element: JQuery<HTMLElement>) {
			super(element);
			this.roSelects = element.find("select");
		}

		private readonly roSelects: JQuery<HTMLElement>;

		private isUnique(value: string): boolean {
			const selections: Array<string> = [];
			this.roSelects.each(function () { if ($(this).val() !== "") selections.push($(this).val() as string); });
			return $.grep(selections, function (n) { return (n === value); }).length === 1;
		}

		validate(selectedElement?: HTMLElement): boolean {
			let valid = true;
			const validator = this as RankOrderValidator;

			this.roSelects.each(function (index, element) {

				const currentValue: string = $(element).val() as string;
				const errorLabel: JQuery<HTMLElement> = $("#" + $(element).attr("id") + "-error");

				if (validator.required && currentValue === "") {
					// only call responseRequired if selected element is null (submit) or selected element matches current element in iteration
					if (!selectedElement || element === selectedElement) {
						valid = validator.setResponseRequired(errorLabel);
					}
				}
				else if (!validator.isUnique(currentValue)) {
					validator.setInvalidResponse(errorLabel);
					valid = false;
				}
				else
					validator.clearErrorMessage(errorLabel);
			});
			return valid;
		}

		attachEventHandler(validator: RankOrderValidator) {
			validator.roSelects.change(function () { validator.validate(this); });
		}

		hasResponses() {
			let hasResponses = false;
			this.roSelects.each(function () {
				if ($(this).val() !== "") { hasResponses = true; return false; }
			});
			return hasResponses;
		}
	}

	class TextBoxValidator extends ItemValidatorBase {

		constructor(element: JQuery<HTMLElement>) {
			super(element);
			this.textBox = element.find("input");
		}

		private readonly textBox: JQuery<HTMLElement>;

		validate(selectedElement?: HTMLElement): boolean {
			if (!this.required) return true;
			let valid = false;
			const text: string = this.textBox.val() as string || "";
			const _length: number = text.trim().length;

			if (_length === 0) valid = this.setResponseRequired();
			else {
				this.clearErrorMessage();
				valid = true;
			}
			return valid;
		}

		attachEventHandler(validator: TextBoxValidator) {
			validator.textBox.on("ready keyup", function (this: HTMLElement) {
				validator.validate(this);
			});
		}

		hasResponses() {
			return this.textBox.val() !== "";
		}
	}

	class TextAreaValidator extends ItemValidatorBase {

		constructor(element: JQuery<HTMLElement>) {
			super(element);
			this.textArea = element.find("textarea");
			this.wordCountLabel = $(this.textArea.data("count"));
			this.wordCountLabel.text(this.countWords(this.textArea.val() as string));

			if (element.data("usesidenav") != "True" && element.data("responserequired") === "True") $("#next").addClass("invisible");
			else element.find(".textarea-submit-confirmation").addClass("invisible");
		}

		private readonly textArea: JQuery<HTMLElement>;
		private wordCountLabel: JQuery<HTMLElement>;

		validate(selectedElement?: HTMLElement): boolean {
			if (!this.required) return true;
			let valid = false;
			const text: string = this.textArea.val() as string || "";
			const _length: number = text.trim().length;

			if (_length === 0) valid = this.setResponseRequired();
			else if (!selectedElement && _length < 2) this.setInvalidResponse();  // only validate length on submit
			else {
				this.clearErrorMessage();
				valid = true;
			}
			return valid;
		}

		private countWords = function (text: string): number {
			const _match = text.match(/\S+/g);
			return _match ? _match.length : 0;
		}

		attachEventHandler(validator: TextAreaValidator) {
			validator.textArea.on("ready keyup focus blur", function (this: HTMLElement) {
				validator.wordCountLabel.text(validator.countWords($(this).val() as string));
				validator.validate(this);
			});
		}

		hasResponses() {
			return this.textArea.val() !== "";
		}
	}

	class CheckBoxValidator extends ItemValidatorBase {

		constructor(element: JQuery<HTMLElement>) {
			super(element);
			this.validationExpression = element.data("validationexpression");
			this.maxSelections = element.data("selectionsallowed");
			this.tooManyResponsesMessage = element.data("msg-toomany");
			this.towFewResponsesMessage = element.data("msg-toofew");
		}

		private readonly validationExpression: string;
		private readonly maxSelections: number;
		private readonly tooManyResponsesMessage: string;
		private readonly towFewResponsesMessage: string;

		validate(selectedElement?: HTMLElement): boolean {
			let valid = false;
			// Only add error message on submit, change or clear on check changed
			if (!selectedElement || this.hasErrorMessage) {
				const numChecked: number = this.validationElement.find(":checked").length;
				if (this.required && numChecked === 0)
					valid = this.setResponseRequired();
				else if (numChecked > this.maxSelections) {
					this.errorLabel.html(this.tooManyResponsesMessage);
					document.getElementById('surveyForm')!.scrollTo(0, this.errorLabel.position().top + 50)
				}
				else if (numChecked < this.minSelections) {
					this.errorLabel.html(this.towFewResponsesMessage);
					document.getElementById('surveyForm')!.scrollTo(0, this.errorLabel.position().top + 50)
				}
				else {
					this.clearErrorMessage();
					valid = true;
				}
			}
			return valid;
		}

		attachEventHandler(validator: CheckBoxValidator): void {
			const checkboxes: JQuery<HTMLElement> = this.validationElement.find(":checkbox");
			checkboxes.change(function () { validator.validate(this); });
		}

		hasResponses() {
			return this.validationElement.find(":checked").length > 0;
		}

		// Determine the min selections required for a checkbox list.
		// 1. The question "validation expression" contains the minimum number of selections required.
		// 2. To support backwards compatability, if the validation expression does not contain a number then:
		//		a. If the response required flag is set then min required is equal to max allowed
		//		b. If the response is not required then min required is set equal to zero.
		private get minSelections() {
			// item validation expression is current storage for the number of minimum responses required for an item (e.g. 2)
			// minRequired logic for backwards compatibility
			let minSelections: number = parseInt(this.validationExpression);
			if (isNaN(minSelections))
				minSelections = (this.required ? this.maxSelections : 0);
			return minSelections;
		}
	}

	class DropDownValidator extends ItemValidatorBase {

		constructor(element: JQuery<HTMLElement>) {
			super(element);
			this.dropdown = element.find("select");
		}

		private readonly dropdown: JQuery<HTMLElement>;

		validate(): boolean {
			if (!this.required) return true;
			const selectedValue: string = $(this.dropdown).val() as string;
			if (selectedValue === "") {
				return this.setResponseRequired();
			}
			else {
				this.clearErrorMessage();
				return true;
			}
		}

		attachEventHandler(validator: DropDownValidator) {
			validator.dropdown.change(function () { validator.validate(); });
		}

		hasResponses() {
			return $(this.dropdown).val() != "";
		}
	}

	class RadioButtonValidator extends ItemValidatorBase {

		constructor(element: JQuery<HTMLElement>) {
			super(element);
			this.radioButtons = element.find("input[type='radio']");
			this.buttonGroups = element.find("input[type='radio']").parent().parent()
		}

		private readonly radioButtons: JQuery<HTMLElement>;
		private readonly buttonGroups: JQuery<HTMLElement>;

		validate(): boolean {
			if (!this.required) return true;
			const selected: JQuery<HTMLElement> = this.validationElement.find("input[type='radio']:checked");  // todo: why doesn't this.radioButtons.find(":checked") work?
			if (selected.length === 0) {
				return this.setResponseRequired();
			}
			else {
				this.clearErrorMessage();
				return true;
			}
		}

		attachEventHandler(validator: RadioButtonValidator) {
			this.radioButtons.on("change", () => { validator.validate() })
			this.buttonGroups.on("click", () => { validator.clearErrorMessage(); });
		}

		hasResponses() {
			return this.validationElement.find("input[type='radio']:checked").length > 0;
		}
	}

	class MostLeastValidator extends ItemValidatorBase {

		constructor(element: JQuery<HTMLElement>) {
			super(element);
			this.radioButtons = element.find("input[type='radio']");
		}

		private readonly radioButtons: JQuery<HTMLElement>;

		validate(selectedElement?: HTMLInputElement): boolean {
			let valid = false;
			if (selectedElement) {
				// Get the parent div for the radio buttons
				const valGroup: JQuery<HTMLElement> = $(selectedElement).closest(".val-group");
				// Get the column of radio buttons (the most or least column)
				const rbC = valGroup.find("label[data-name='" + $(selectedElement).parent().data("name") + "']");
				// Get the row of radio buttons
				const rbR = valGroup.find("label[data-group='" + $(selectedElement).parent().data("group") + "']");
				// Deselect the radio buttons in the column
				rbC.removeClass("active");
				rbC.children("input[type='radio']").prop("checked", false);
				// Deselect the radio buttons in the row
				rbR.removeClass("active");
				rbR.children("input[type='radio']").prop("checked", false);

				$(selectedElement)
					.addClass("active")
					.parent("label").addClass("active");
				selectedElement.checked = true;
			}

			if (!selectedElement || this.hasErrorMessage) {
				const numChecked: number = this.validationElement.find(":checked").length;

				if (this.required && numChecked === 0)
					valid = this.setResponseRequired();
				else if (this.required && numChecked < 2) {
					this.setInvalidResponse();
				}
				else {
					this.clearErrorMessage();
					valid = true;
				}
			}
			return valid;
		}

		attachEventHandler(validator: MostLeastValidator) {
			this.radioButtons.on("change", function () { validator.validate(this as HTMLInputElement); });
		}

		hasResponses() {
			return this.validationElement.find(":checked").length > 0;
		}
	}

	class RankOrderDragDropValidator extends ItemValidatorBase {

		constructor(element: JQuery<HTMLElement>) {
			super(element);
			this.dragDrop = element.find("ul");
			this.source = element.find("[data-element='source']");
			this.dest = element.find("[data-element='dest']");
		}

		private readonly dragDrop: JQuery<HTMLElement>;
		private readonly source: JQuery<HTMLElement>;
		private readonly dest: JQuery<HTMLElement>;

		validate(selectedElement?: HTMLElement): boolean {
			let valid = true;
			const validator = this as RankOrderDragDropValidator;

			if (!selectedElement || this.hasErrorMessage) {
				if (this.source.children().length > 0) {
					valid = validator.setResponseRequired();
				}
				else validator.clearErrorMessage();
			}
			return valid;
		}

		attachEventHandler(validator: RankOrderDragDropValidator) {
			validator.dragDrop.on("drop", function () { validator.validate(this); });
		}

		hasResponses() {
			return this.dest.find("[data-type='ro']").length > 0;
		}
	}

	return {
		init: _init,
		showHideNextButtonTextArea: _showHideNextButtonTextArea
	}
})($);